import { COLORS } from '@/constants/colors';

// Layout Constants
export const HEADER_HEIGHT = 360;
export const HEADER_OFFSET_LEFT = -30;
export const HEADER_OFFSET_TOP = -250;
export const HEADER_BORDER_RADIUS = 24;

export const SCROLL_VIEW_PADDING_TOP = 24;
export const SCROLL_VIEW_PADDING_BOTTOM = 100;
export const SCROLL_VIEW_PADDING_HORIZONTAL = 16;

// Component Sizes
export const AVATAR_SIZE = 48;
export const AVATAR_BORDER_RADIUS = 8;
export const ICON_SIZE = 24;
export const ICON_SIZE_SMALL = 16;
export const ICON_SIZE_LARGE = 20;

export const PAYMENT_ICON_SIZE = 40;

// Border Widths
export const BORDER_WIDTH_THIN = 1;
export const BORDER_WIDTH_MEDIUM = 2;

// Border Radius
export const BORDER_RADIUS_SMALL = 8;
export const BORDER_RADIUS_MEDIUM = 12;
export const BORDER_RADIUS_LARGE = 16;

// Spacing
export const SPACING_XS = 2;
export const SPACING_SM = 3;
export const SPACING_MD = 4;

// Font Sizes
export const FONT_SIZE_XS = 12;
export const FONT_SIZE_SM = 13;
export const FONT_SIZE_MD = 14;
export const FONT_SIZE_BASE = 16;
export const FONT_SIZE_LG = 18;
export const FONT_SIZE_XL = 20;
export const FONT_SIZE_2XL = 24;
export const FONT_SIZE_3XL = 28;
export const FONT_SIZE_4XL = 32;
export const FONT_SIZE_5XL = 48;

// Input Styles
export const INPUT_PADDING = 16;
export const INPUT_PADDING_SMALL = 12;
export const INPUT_FONT_SIZE = 16;

// Button Styles
export const BUTTON_PADDING = 16;
export const BUTTON_BORDER_RADIUS = 12;

// Card Styles
export const CARD_PADDING = 16;
export const CARD_BORDER_RADIUS = 16;

// Validation
export const MIN_WITHDRAWAL_AMOUNT = 50;
export const CARD_NUMBER_MIN_LENGTH = 16;
export const CARD_EXPIRY_MIN_LENGTH = 4;
export const CARD_CVC_MIN_LENGTH = 3;
export const BLIK_CODE_LENGTH = 6;

// Colors
export const getCardBackgroundColor = (isDark: boolean) => 
  isDark ? '#1C1C1C' : COLORS.WHITE;

export const getCardBorderColor = (isDark: boolean) => 
  isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

export const getInputBackgroundColor = (isDark: boolean) => 
  isDark ? 'rgba(255, 255, 255, 0.05)' : '#F5F5F5';

export const getInputBorderColor = (isDark: boolean, isActive?: boolean) => 
  isActive 
    ? COLORS.PRIMARY 
    : isDark 
    ? 'rgba(255, 255, 255, 0.1)' 
    : '#E5E5E5';

export const getTabBackgroundColor = (isDark: boolean, isActive: boolean) => 
  isActive 
    ? COLORS.PRIMARY 
    : isDark 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(0, 0, 0, 0.05)';

export const getTabBorderColor = (isDark: boolean, isActive: boolean) => 
  isActive 
    ? COLORS.PRIMARY 
    : isDark 
    ? 'rgba(255, 255, 255, 0.2)' 
    : 'rgba(0, 0, 0, 0.1)';

export const getTabTextColor = (isActive: boolean, textColor: string) => 
  isActive ? COLORS.WHITE : textColor;

export const getButtonBackgroundColor = (isEnabled: boolean) => 
  isEnabled ? '#5A7A8F' : COLORS.GRAY_400;

export const getSeparatorColor = (isDark: boolean) => 
  isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

// Alert Colors
export const ALERT_MINIMUM_WITHDRAWAL_BG = '#B7859E12';
export const ALERT_MINIMUM_WITHDRAWAL_COLOR = '#B7859E';

export const getStripeInfoBackgroundColor = (isDark: boolean) => 
  isDark ? 'rgba(255, 255, 255, 0.05)' : '#E8F5E9';

export const getStripeInfoTextColor = (isDark: boolean, textColor: string) => 
  isDark ? textColor : '#2E7D32';

export const getStripeInfoIconColor = (isDark: boolean) => 
  isDark ? COLORS.SUCCESS : '#2E7D32';


